// extracted by mini-css-extract-plugin
module.exports = {"heading":"TimelineBlock_heading__PPmj1","description":"TimelineBlock_description__mzgBo","timeline":"TimelineBlock_timeline__KQict"};